import React from 'react'
import PropTypes from 'prop-types'
import {Select} from "antd"

SelectMulti.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    platforms: PropTypes.array.isRequired
}

function SelectMulti(props) {
    const {label, onChange, value, platforms} = props

    return (
        <div className="CheckboxInput">
            <label htmlFor="">{label} <span className='Required'>*</span></label>
            <Select
                mode="multiple"
                style={{width: '100%'}}
                placeholder="Please select platform"
                value={value}
                onChange={onChange}
            >
                {
                    !!platforms && platforms.length > 0 && platforms.map(item => (
                        <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>
                    ))
                }

            </Select>
        </div>
    )
}

export default SelectMulti